import { ArrowBack } from '@mui/icons-material';
import { Card, CardContent, CardHeader, IconButton, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import FormBJ from './Form/FormBj';
import FormGaji from './Form/FormGaji';
import FormGU from './Form/FormGu';
import FormModal from './Form/FormModal';
import FormTU from './Form/FormTu';
import FormUP from './Form/FormUp';

const FormProviderz = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const locationState = location.state || null;
    const [jenis, setJenis] = useState(null);
    const [jenisLs, setJenisLs] = useState(null);
    const [pencairan, setPencairan] = useState(null);

    console.log(locationState);
    useEffect(() => {
        setJenis(locationState.jenis)
        setJenisLs(locationState.jenis_ls)
        setPencairan(locationState.pencairan)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Card>
            <CardHeader
                title={
                    <Typography variant='h5'>Kembali</Typography>
                }
                avatar={
                    <Tooltip title="Kembali">
                        <IconButton variant="outlined" onClick={() => {
                            navigate("/bnd/pencairan", { replace: true })
                        }} color="error"><ArrowBack /></IconButton>
                    </Tooltip>
                }
            // subheader="September 14, 2016"
            />
            <CardContent>
                {jenis === 'UP' && <FormUP pencairan={pencairan} />}
                {jenis === 'TU' && <FormTU pencairan={pencairan} />}
                {jenis === 'GU' && <FormGU pencairan={pencairan} />}
                {jenis === 'LS' && jenisLs === 'Modal' && <FormModal pencairan={pencairan} />}
                {jenis === 'LS' && jenisLs === 'Barang Jasa' && <FormBJ pencairan={pencairan} />}
                {jenis === 'LS' && jenisLs === 'Gaji' && <FormGaji pencairan={pencairan} />}
            </CardContent>
        </Card>

    )
}

export default FormProviderz